import { ErrorBoundary } from 'react-error-boundary';
import { Container, Heading } from 'yoso';
import { HistoryErrorFallback } from '~/components/Error/History/HistoryErrorFallback';
import { T } from '~/components/I18n';
import {
  useLandHistoryLastVisitedDate,
  useLandHistoryParams,
  useNewWinningLandHistory,
} from '~/components/Land/History/LandHistory.hooks';
import { LandHistoryList } from '~/components/Land/History/List/LandHistoryList';
import { LandHistoryReward } from '~/components/Land/History/Reward/LandHistoryReward';
import { LandHistoryTabs } from '~/components/Land/History/Tab/LandHistoryTabs';
import party from '~/components/Land/History/party.animated.png';
import { Alert } from '~/components/Modal/Alert/Alert';
import { OpenModal } from '~/components/Modal/Open/OpenModal';
import { Page } from '~/components/Page';
import { useUnmount } from '~/components/Util/react';
import styles from './LandHistoryPage.module.scss';

export const LandHistoryPage = () => {
  const { category } = useLandHistoryParams();
  const { value: latestWinning, update } = useNewWinningLandHistory();
  const { visit } = useLandHistoryLastVisitedDate();

  useUnmount(() => {
    visit();
    update();
  });

  return (
    <Page className={styles.root}>
      <Container margin="auto">
        <div className={styles.header}>
          <Heading className={styles.title} level={3}>
            <T name="citizen_land_myhistory_title" />
          </Heading>
          <LandHistoryReward className={styles.reward} />
          <p className={styles.description}>
            <T name="citizen_land_myhistory_guide_desc1" />
          </p>
        </div>
        <LandHistoryTabs className={styles.tabs} />
        <ErrorBoundary FallbackComponent={HistoryErrorFallback} resetKeys={[category]}>
          <LandHistoryList className={styles.list} category={category} />
        </ErrorBoundary>
      </Container>
      <OpenModal disabled={!latestWinning} onClose={update}>
        <Alert
          icon={<img src={party} alt="party" width={81} height={81} />}
          title={<T name="citizen_land_menu_myhistory_win_desc" options={[latestWinning?.week]} />}
          // data-event="impression"
          // data-event-category="land_myhistory_congrats_popup"
          // data-event-impression-id="{category}"
        />
      </OpenModal>
    </Page>
  );
};
